import ScheduleBoardProvider from './ScheduleBoardProvider.tsx';

const ScheduleBoard = () => <ScheduleBoardProvider mode="scheduler" />;

export default ScheduleBoard;
